var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFulltimeJob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0992 3.7C17.7992 2.6 20.6992 2 23.6992 2C35.8992 2 45.6992 11.8 45.6992 24C45.6992 29.4 43.7992 34.3 40.4992 38.2C40.1992 38.6 39.8992 38.9 39.5992 39.2C39.0992 39.7 38.5992 40.2 37.9992 40.7C34.5992 43.7 30.1992 45.6 25.3992 46C24.7992 46 24.2992 46.1 23.6992 46.1C23.0992 46.1 22.5992 46.1 21.9992 46C17.4992 45.7 13.2992 43.9 9.99922 41.3C9.39922 40.8 8.79922 40.3 8.19922 39.7C7.89922 39.5 7.69922 39.2 7.49922 38.9C3.89922 35 1.69922 29.7 1.69922 24C1.69922 21.5 2.09922 19.2 2.89922 17",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5L8 10L3 5",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 10C14 13.3 11.3 16 8 16H7.9L8 10H2C2 6.7 4.7 4 8 4C11.3 4 14 6.7 14 10Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4V2",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2H10",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10L7.9 16C4.6 16 2 13.3 2 10H8Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0004 17C26.817 17 29.1004 14.7166 29.1004 11.9C29.1004 9.08333 26.817 6.79999 24.0004 6.79999C21.1837 6.79999 18.9004 9.08333 18.9004 11.9C18.9004 14.7166 21.1837 17 24.0004 17Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2008 29.7H15.8008C14.7008 29.7 13.8008 28.8 13.8008 27.7V25.4C13.8008 20.8 17.6008 17 22.2008 17H25.7008C30.3008 17 34.1008 20.8 34.1008 25.4V27.7C34.2008 28.9 33.3008 29.7 32.2008 29.7Z",
    fill: "white",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 20.9H17.5V29.7H30.4V20.9Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9004 27.5C25.005 27.5 25.9004 26.6046 25.9004 25.5C25.9004 24.3954 25.005 23.5 23.9004 23.5C22.7958 23.5 21.9004 24.3954 21.9004 25.5C21.9004 26.6046 22.7958 27.5 23.9004 27.5Z",
    fill: "#F6BE00",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38 29.7V40.6C34.6 43.6 30.2 45.5 25.4 45.9C24.8 45.9 24.3 46 23.7 46C23.1 46 22.6 46 22 45.9C17.5 45.6 13.3 43.8 10 41.2V29.7H38Z",
    fill: "#8CA0C4",
    stroke: "#1D4289",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFulltimeJob);
export default __webpack_public_path__ + "static/media/fulltime-job.32bf2964b94a5d5b0e5f0c0749427ef0.svg";
export { ForwardRef as ReactComponent };